import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  checkboxControl: {
    '&.dataTerms': {
      padding: 0,
      margin: 0,
      display: 'block',
      position: 'relative',
      '& .MuiCheckbox-root': {
        position: 'absolute',
        left: 0
      },
      '& .policyContainer': {
        height: 165,
        padding: 25,
      }
    },
    '&.commission_opt_out': {
      marginTop: '16px'
    },
    paddingLeft: 11,
    '& .MuiButtonBase-root.Mui-checked': {
      '& .MuiSvgIcon-root': {
        color: '#2D91E9'
      }
    },
    '&': {
      alignItems: 'self-start'
    },
    '& .MuiFormControlLabel-label': {
      color: '#4a4a4a',
      fontSize: 16
    },
    '& .MuiSvgIcon-root': {
      fontSize: '2.2rem',
      marginRight: 10,
      color: '#ccc'
    },
    '& .MuiIconButton-root': {
      //padding: '0 9px 9px 9px'
    }
  }
});
